import { render } from "./StickyNavigation.vue?vue&type=template&id=798faeea&scoped=true&ts=true"
import script from "./StickyNavigation.vue?vue&type=script&lang=ts"
export * from "./StickyNavigation.vue?vue&type=script&lang=ts"

import "./StickyNavigation.vue?vue&type=style&index=0&id=798faeea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798faeea"]])

export default __exports__